import { useMutation, useQuery } from '@tanstack/react-query';
import { vanCancel, vanCancelStatus } from '@apis/vancancel';
import { IVanCancelRequest } from '@dataTypes/vanCancelTypes';
import { TOTALSALES } from '@components/totalSales/queryKey/queryKey';

export const useVanCancel = (kisTotalSalesId: number | undefined, vanKey: string | undefined) => {
  const { mutateAsync: vanCancelAsync } = useMutation({
    mutationFn: () => vanCancel({ kisTotalSalesId, vanKey }),
  });

  const { data: vanCancelStatusData, isLoading: vanCancelStatusLoading } = useQuery({
    queryKey: [TOTALSALES.VANCANCELSTATUS, kisTotalSalesId],
    queryFn: () => vanCancelStatus(kisTotalSalesId),
    enabled: !!kisTotalSalesId,
  });

  return { vanCancelAsync, vanCancelStatusData, vanCancelStatusLoading };
};
